import { get } from 'lodash';
import { defaultTextColor } from '../../utils/defaults';
import { getTextAlign } from '../../utils/get-text-align';
export const getText = ({ region, css, isRtl, cssClass, componentStylePath, bolden = false, }) => {
    const regionTextStyle = get(region, componentStylePath, {});
    const textStyle = css[cssClass];
    const textAlign = getTextAlign(regionTextStyle.align, isRtl ? 'right' : 'left');
    return {
        align: textAlign,
        color: regionTextStyle.color || textStyle.color || defaultTextColor,
        fontFamily: regionTextStyle.fontFamily || textStyle.fontFamily,
        fontSize: regionTextStyle.fontSize || textStyle.fontSize,
        fontStyle: regionTextStyle.fontStyle || textStyle.fontStyle,
        fontWeight: regionTextStyle.fontWeight ?? (bolden ? 'bold' : textStyle.fontWeight),
        textDecoration: regionTextStyle.textDecoration || textStyle.textDecoration,
        lineHeight: regionTextStyle.lineHeight || textStyle.lineHeight,
    };
};
//# sourceMappingURL=get-text.js.map